"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var recoil_1 = require("recoil");
var react_router_dom_1 = require("react-router-dom");
var preview_20_svg_1 = __importDefault(require("@/assets/svg/preview-20.svg"));
var components_1 = require("@/components");
var hooks_1 = require("@/hooks");
var store_1 = require("@/store");
var constants_1 = require("@/constants");
var utils_1 = require("@/utils");
var ApplicationFormPreview_component_1 = require("@/components/ApplicationForm/ApplicationFormPreview/ApplicationFormPreview.component");
var Button_component_1 = require("@/components/common/Button/Button.component");
var Styled = __importStar(require("./ApplicationFormList.styled"));
var ApplicationFormPreview = function (_a) {
    var questions = _a.questions;
    var _b = __read((0, hooks_1.useToggleState)(false), 2), modalOpened = _b[0], toggleModalOpened = _b[1];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.Center, { children: (0, jsx_runtime_1.jsx)(components_1.Button, { Icon: preview_20_svg_1.default, shape: Button_component_1.ButtonShape.smallIcon, onClick: toggleModalOpened }, void 0) }, void 0), modalOpened && ((0, jsx_runtime_1.jsx)(ApplicationFormPreview_component_1.ApplicationFormPreviewModal, { questions: questions, toggleModalOpened: toggleModalOpened }, void 0))] }, void 0));
};
var ApplicationFormList = function () {
    var _a;
    var _b = __read((0, react_router_dom_1.useSearchParams)(), 2), searchParams = _b[0], setSearchParams = _b[1];
    var teamName = searchParams.get('team');
    var teamId = (0, recoil_1.useRecoilValue)((0, store_1.$teamIdByName)(teamName));
    var generationNumber = (0, recoil_1.useRecoilValue)(store_1.$generationNumber);
    var page = searchParams.get('page') || '1';
    var size = searchParams.get('size') || '20';
    var searchWord = searchParams.get('searchWord') || '';
    var _c = (0, react_router_dom_1.useLocation)(), pathname = _c.pathname, search = _c.search;
    var _d = __read((0, react_2.useState)([
        { accessor: 'team.name', type: constants_1.SORT_TYPE.DEFAULT },
        { accessor: 'name', type: constants_1.SORT_TYPE.DEFAULT },
        { accessor: 'createdAt', type: constants_1.SORT_TYPE.DEFAULT },
        { accessor: 'updatedAt', type: constants_1.SORT_TYPE.DEFAULT },
    ]), 2), sortTypes = _d[0], setSortTypes = _d[1];
    var sortParam = (0, react_2.useMemo)(function () {
        var matched = sortTypes.find(function (sortType) { return sortType.type !== constants_1.SORT_TYPE.DEFAULT; });
        if (!matched)
            return '';
        var accessor = matched.accessor, type = matched.type;
        return "".concat(accessor, ",").concat(type);
    }, [sortTypes]);
    var applicationFormParams = (0, react_2.useMemo)(function () { return ({
        page: parseInt(page, 10) - 1,
        size: parseInt(size, 10),
        teamId: parseInt(teamId, 10) || undefined,
        searchWord: searchWord,
        sort: sortParam,
        generationNumber: generationNumber,
    }); }, [page, size, teamId, searchWord, sortParam, generationNumber]);
    var _e = __read((0, react_2.useState)(0), 2), totalCount = _e[0], setTotalCount = _e[1];
    var _f = __read((0, recoil_1.useRecoilStateLoadable)((0, store_1.$applicationForms)(applicationFormParams)), 1), _g = _f[0], state = _g.state, tableRows = _g.contents;
    var isLoading = state === 'loading';
    var _h = __read((0, react_2.useState)(tableRows.data || []), 2), loadedTableRows = _h[0], setLoadedTableRows = _h[1];
    var _j = (0, hooks_1.usePagination)({
        totalCount: (_a = tableRows.page) === null || _a === void 0 ? void 0 : _a.totalCount,
    }), pageOptions = _j.pageOptions, handleChangePage = _j.handleChangePage, handleChangeSize = _j.handleChangeSize;
    var _k = (0, hooks_1.useDirty)(1), makeDirty = _k.makeDirty, isDirty = _k.isDirty;
    var columns = [
        {
            title: '플랫폼',
            accessor: 'team.name',
            widthRatio: '9%',
        },
        {
            title: '지원서 설문지 문서명',
            accessor: 'name',
            idAccessor: 'applicationFormId',
            widthRatio: '28%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue, id = _a.id;
                return ((0, jsx_runtime_1.jsxs)(Styled.FormTitleWrapper, __assign({ title: cellValue }, { children: [(0, jsx_runtime_1.jsx)(Styled.FormTitle, { children: cellValue }, void 0), (0, jsx_runtime_1.jsx)(Styled.TitleLink, { to: "".concat(constants_1.PATH.APPLICATION_FORM, "/").concat(id), state: { from: "".concat(pathname).concat(search) } }, void 0)] }), void 0));
            },
        },
        {
            title: '작성자',
            accessor: 'createdBy',
            widthRatio: '14%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                var _b = __read(cellValue.split('_'), 2), team = _b[0], role = _b[1];
                return ((0, jsx_runtime_1.jsx)(Styled.CustomUserProfile, { children: (0, jsx_runtime_1.jsx)(components_1.UserProfile, { team: team, role: role, showBackground: false }, void 0) }, void 0));
            },
        },
        {
            title: '작성일시',
            accessor: 'createdAt',
            widthRatio: '21%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return (0, utils_1.formatDate)(cellValue, 'YYYY년 M월 D일 A h시 m분');
            },
        },
        {
            title: '수정일시',
            accessor: 'updatedAt',
            widthRatio: '21%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return (0, utils_1.formatDate)(cellValue, 'YYYY년 M월 D일 A h시 m분');
            },
        },
        {
            title: '미리보기',
            accessor: 'questions',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return ((0, jsx_runtime_1.jsx)(ApplicationFormPreview, { questions: cellValue }, void 0));
            },
            widthRatio: '7%',
        },
    ];
    (0, react_2.useEffect)(function () {
        if (!isLoading) {
            setLoadedTableRows(tableRows.data);
            setTotalCount(tableRows.page.totalCount);
            makeDirty();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, tableRows]);
    (0, react_2.useEffect)(function () {
        searchParams.delete('searchWord');
        setSearchParams(searchParams);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [teamName]);
    (0, react_2.useLayoutEffect)(function () {
        if (isDirty && !isLoading) {
            window.scrollTo({ top: 179, left: 0, behavior: 'smooth' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedTableRows]);
    return ((0, jsx_runtime_1.jsxs)(Styled.PageWrapper, { children: [(0, jsx_runtime_1.jsx)(Styled.Heading, { children: "\uC9C0\uC6D0\uC11C \uC124\uBB38\uC9C0 \uB0B4\uC5ED" }, void 0), (0, jsx_runtime_1.jsxs)(Styled.StickyContainer, { children: [(0, jsx_runtime_1.jsx)(components_1.TeamNavigationTabs, {}, void 0), (0, jsx_runtime_1.jsx)(components_1.SearchOptionBar, { placeholder: "\uC9C0\uC6D0\uC11C \uC124\uBB38\uC9C0 \uBB38\uC11C\uBA85 \uAC80\uC0C9" }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(components_1.Table, { prefix: "application-form", topStickyHeight: 14.1, columns: columns, rows: loadedTableRows, isLoading: isLoading, supportBar: {
                    totalCount: totalCount,
                    totalSummaryText: '총 지원설문지',
                    buttons: [
                        (0, jsx_runtime_1.jsx)(components_1.Link, __assign({ to: constants_1.PATH.APPLICATION_FORM_CREATE }, { children: (0, jsx_runtime_1.jsx)(components_1.Button, __assign({ "$size": Button_component_1.ButtonSize.xs, shape: Button_component_1.ButtonShape.primary }, { children: "\uC9C0\uC6D0\uC11C \uC124\uBB38\uC9C0 \uC791\uC131" }), void 0) }), void 0),
                    ],
                }, sortOptions: {
                    sortTypes: sortTypes,
                    disableMultiSort: true,
                    handleSortColumn: function (_sortTypes) {
                        setSortTypes(_sortTypes);
                    },
                }, pagination: (0, jsx_runtime_1.jsx)(components_1.Pagination, { pageOptions: pageOptions, selectableSize: {
                        selectBoxPosition: loadedTableRows.length > 3 ? 'top' : 'bottom',
                        handleChangeSize: handleChangeSize,
                    }, handleChangePage: handleChangePage }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(components_1.BottomCTA, __assign({ boundaries: {
                    visibility: { topHeight: 179, bottomHeight: 20 },
                    noAnimation: { bottomHeight: 20 },
                } }, { children: (0, jsx_runtime_1.jsx)(components_1.Pagination, { pageOptions: pageOptions, selectableSize: {
                        selectBoxPosition: loadedTableRows.length > 3 ? 'top' : 'bottom',
                        handleChangeSize: handleChangeSize,
                    }, handleChangePage: handleChangePage }, void 0) }), void 0)] }, void 0));
};
exports.default = ApplicationFormList;
